<template>
  <div class="cb-tree">
    <!--  左侧树形菜单-->
    <el-tree
      v-show="showVisible"
      :props="defaultProps"
      :empty-text="emptyText"
      class="leftTree"
      :data="treeNodeList"
      :default-expanded-keys="[currentNodeKeyValue || defaultId]"
      :current-node-key="`${('id', currentNodeKeyValue || defaultId)}`"
      @node-click="handleTreeNodeClick"
      :expand-on-click-node="false"
      highlight-current
      ref="tree"
      :node-key="nodeKey"
      v-bind="$attrs"
    >
      <slot
        name="treeNode"
        v-if="$scopedSlots.treeNode"
        :node="node"
        :data="data"
        slot-scope="{ node, data }"
      />
      <span v-else class="custom-tree-node" >
        <span>{{ node.label }}</span>
        <span style="font-size: 20px" @click.stop="flodClick('flod')">
          <i v-if="data.id == defaultId" class="el-icon-s-fold"></i>
        </span>
      </span>
    </el-tree>
    <div v-show="!show" class="flodIcon leftTreeFlod">
      <i class="el-icon-s-unfold" @click.stop="flodClick('cutout')"></i>
    </div>
  </div>
</template>
<script>
/** 全局左侧树结构组件 */
export default {
  name: "CbTree",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    nodeKey: {
      type: String,
      default: "id",
    },
    treeData: {
      type: Array,
      default: () => [],
    },
    currentNodeKey: {
      default: "",
    },
    leftSpan: {
      type: String,
      default: "3",
    },
    topRootId: {
      type: Number,
      default: 1, //根节点ID
    },
  },
  data() {
    return {
      defaultProps: {
        children: "children",
        label: "title",
      },
      defaultId: 1,
      emptyText: "暂无数据",
      flod: false,
      treeNodeList: [],
      showVisible: false,
      currentNodeKeyValue: "",
    };
  },
  watch: {
    treeData: {
      handler(value) {
        this.treeNodeList = value ? [...value] : [];
        value &&
          value.length > 0 &&
          this.$nextTick(() => {
            this.$refs.tree.setCurrentKey(this.currentNodeKey || value[0].id);
            this.defaultId = this.treeNodeList && this.treeNodeList[0] ? this.treeNodeList[0].id : 1
          });
      },
      deep: true,
      immediate: true,
    },
    show: {
      handler(val) {
        this.showVisible = val;
      },
      immediate: true,
    },
    currentNodeKey: {
      handler(val) {
        this.currentNodeKeyValue = val || "";
        if (val) {
          this.$refs.tree && this.$refs.tree.setCurrentKey(val);
        }
      },
      immediate: true,
    },
    topRootId: {
      handler(val) {
        this.defaultId = val || 1
      },
      immediate: true,
    },
  },
  methods: {
    flodClick(name) {
      this.flod = !this.flod;
      if (name == "flod") {
        this.showVisible = false;
      } else if (name == "cutout") {
        this.showVisible = true;
      }
      this.$emit("flodClick", name);
    },
    handleTreeNodeClick(data, node) {
      this.$emit("node-click", data, node);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/CbTree.vue